export function scrollPageToTop() {
  document.querySelector('#routerView')?.scrollTo({ behavior: 'smooth', top: 0 });
}
